
/* ===== VELANTIS_GIFT — regalo 30 ml por cada 2 perfumes (dropdown propio + layering) ===== */
(function(){
  var box=document.getElementById('cartGift'), itemsEl=document.getElementById('cartItems');
  if(!box||!itemsEl) return;
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function stored(){ try{ return JSON.parse(localStorage.getItem('velantis_gifts')||'[]'); }catch(e){ return []; } }
  function saveSel(arr){ try{ localStorage.setItem('velantis_gifts', JSON.stringify(arr)); }catch(e){} }
  function CAT(){ return window.VELANTIS_CAT||[]; }
  // Layering recomendado — MISMA lógica que la página individual (#/eleva): FNV-1a + grupo r[4]
  // distinto, mismo género r[1], primer candidato con hash%7===0 (o el primero disponible).
  function ghash(s){ var x=2166136261; for(var i=0;i<s.length;i++){ x^=s.charCodeAt(i); x=Math.imul(x,16777619); } return x>>>0; }
  function partnerOf(name){
    var c=CAT(), r=null; for(var i=0;i<c.length;i++){ if(c[i][0]===name){ r=c[i]; break; } }
    if(!r) return null;
    var alt=null;
    for(var i=0;i<c.length;i++){ var s=c[i];
      if(s[1]==='Ambiental'||s[0]===r[0]) continue;
      if(s[4]!==r[4] && s[1]===r[1]){ if(ghash(r[0]+s[0])%7===0){ alt=s; break; } if(!alt) alt=s; }
    }
    return alt?alt[0]:null;
  }
  function opt(val,label,extraCls){ return '<div class="cg-dd-opt'+(extraCls?' '+extraCls:'')+'" data-val="'+esc(val)+'">'+esc(label)+'</div>'; }
  function build(){
    var names=[], units=0;
    [].forEach.call(itemsEl.querySelectorAll('.ci'), function(ci){
      var nm=ci.querySelector('.ci-name'), q=ci.querySelector('.ci-qty span');
      if(!nm) return;
      var sub=(ci.querySelector('.ci-sub')||{}).textContent||'';
      // solo PERFUMES cuentan (excluir difusores, aceites, ambientales y regalos)
      if(/difusor|aceite|aroma de ambiente|regalo/i.test(sub)) return;
      var qty=q?(parseInt(q.textContent,10)||1):1;
      names.push(nm.textContent.trim()); units+=qty;
    });
    /* Con tope. Sin el, un carrito con una cantidad disparatada armaba
       cientos de desplegables y la pestana dejaba de responder. */
    var gifts=Math.min(10, Math.floor(units/2));
    if(!gifts || !names.length){ box.hidden=true; box.innerHTML=''; return; }
    box.hidden=false;
    var sel=stored();
    var html='<div class="cg-head"><span class="cg-badge">🎁 Regalo de tu promoción de relanzamiento</span>'+
      '<span class="cg-sub">Por cada 2 perfumes, un perfume de bolso 30&nbsp;ml GRATIS · elige el aroma o su Layering</span></div>';
    for(var i=0;i<gifts;i++){
      var a=names[i*2], b=names[i*2+1]||names[i*2];
      var pair=(a===b)?[a]:[a,b];
      // opciones: aromas del par + layering recomendado de cada uno
      var opts=pair.map(function(n){ return opt(n,n); }).join('');
      var lay='';
      pair.forEach(function(n){ var p=partnerOf(n); if(p) lay+=opt('LAY::'+n+'::'+p, '✦ Layering: '+n+' + '+p, 'cg-dd-lay'); });
      if(lay) opts+='<div class="cg-dd-sep"></div>'+lay;
      // etiqueta actual
      var cur=sel[i]||pair[0], label=cur;
      if(String(cur).indexOf('LAY::')===0){ var pp=cur.split('::'); label='✦ '+pp[1]+' + '+pp[2]; }
      else if(pair.indexOf(cur)<0){ cur=pair[0]; label=cur; }
      html+='<div class="cg-item"><div class="cg-info"><span class="cg-title">Perfume de bolso · 30&nbsp;ml</span>'+
        '<span class="cg-choose-l">Elige tu aroma</span>'+
        '<div class="cg-dd" data-i="'+i+'" data-val="'+esc(cur)+'">'+
          '<button class="cg-dd-trigger" type="button"><span class="cg-dd-lbl">'+esc(label)+'</span>'+
            '<svg class="cg-dd-cae" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button>'+
          '<div class="cg-dd-panel">'+opts+'</div>'+
        '</div></div><span class="cg-free">GRATIS</span></div>';
    }
    box.innerHTML=html;
    // guardar selección actual por defecto
    var cur2=[]; [].forEach.call(box.querySelectorAll('.cg-dd'),function(d){ cur2.push(d.getAttribute('data-val')); });
    saveSel(cur2);
  }
  // interacción del dropdown
  box.addEventListener('click',function(e){
    var trg=e.target.closest('.cg-dd-trigger');
    if(trg){ var dd=trg.closest('.cg-dd'); var wasOpen=dd.classList.contains('open');
      [].forEach.call(box.querySelectorAll('.cg-dd.open'),function(x){x.classList.remove('open');});
      if(!wasOpen) dd.classList.add('open'); e.stopPropagation(); return; }
    var o=e.target.closest('.cg-dd-opt');
    if(o){ var dd2=o.closest('.cg-dd'); var val=o.getAttribute('data-val');
      var label=o.textContent.trim();
      dd2.setAttribute('data-val',val); dd2.querySelector('.cg-dd-lbl').textContent=label;
      dd2.classList.remove('open');
      var arr=[]; [].forEach.call(box.querySelectorAll('.cg-dd'),function(x){ arr.push(x.getAttribute('data-val')); });
      saveSel(arr); return; }
  });
  document.addEventListener('click',function(e){ if(!e.target.closest('#cartGift .cg-dd')) [].forEach.call(box.querySelectorAll('.cg-dd.open'),function(x){x.classList.remove('open');}); });
  new MutationObserver(build).observe(itemsEl, {childList:true, subtree:true});
  build();
})();
